import {ContentActions, ContentOptions} from './types';

export enum BLOCK_TYPE { // Maintain alphabetical order
  API_REQUEST = 'api_request',
  AWS_S3 = 'aws_s3',
  CODE_BLOCK = 'code_block',
  CUSTOM_APP = 'custom_app',
  ELSE_ = 'else_', // created by IF_START
  EMAIL = 'email',
  FOR_START = 'for_start', // creates for_end
  FOR_END = 'for_end',
  IF_END = 'if_end', // created by IF_START
  IF_START = 'if_start',
  KPI_CARD = 'kpi_card',
  OPEN_AI = 'open_ai',
  PARAGRAPH = 'p',
  PARAMETER = 'parameter',
  SLACK = 'slack',
  SQL = 'sql',
  TABLEAU = 'tableau',
  SFTP = 'sftp',
  SMTP = 'smtp',
  WRITEBACK = 'writeback',
  TABLEAU_EMBED = 'tableau_embed',
  EXTERNAL_FILE = 'external_file',
  GDRIVE = 'gdrive',
}

export enum EXECUTION_STATUS {
  SUCCESS = 'success',
  FAILED = 'failed',
  RUNNING = 'running',
  PENDING = 'pending',
  CANCELLED = 'cancelled',
}

export enum CONTEXT_TYPE {
  NOTEBOOK = 'notebook',
  REPORT = 'report',
  TABLEAU_EMBED = 'tableau_embed',
}

export const LAST_RESULT_KEY: string = 'last_result';

export const defaultContentOptions: ContentOptions = {
  allowCollapse: true,
  showDelete: true,
  showSave: true, /* saved block */
  showExportOptions: true,
  showToolbar: true,
  showRun: true,
  showPreview: true,
  readOnly: undefined,
  autosave: true,
  loadResult: undefined,
  showAttachments: true,
  showHeader: false,
  showFooter: false,
  showResult: true,
  showSlackThreadTS: true,
};

export const defaultContentActions: ContentActions = {
  onDelete: undefined,
}
